import React from 'react';
import { motion } from 'framer-motion';

const BEATS = [
  { plain: 'The hint lands — and their', accent: 'heart skips.' },
  { plain: 'The countdown starts — and they', accent: "can't stop checking." },
  { plain: 'It opens — and the whole room', accent: 'goes quiet.' },
  { plain: 'Then the gasp. The hand over the mouth. The', accent: 'happy tears.' },
  { plain: 'And a memory they will', accent: 'retell for years.' },
];

export const TheMoment = () => (
  <section id="moment" className="relative overflow-hidden py-28 md:py-40" data-testid="the-moment-section">
    <div className="pointer-events-none absolute left-1/2 top-0 h-96 w-96 -translate-x-1/2 rounded-full bg-accent/20 blur-3xl animate-soft-glow" />
    <div className="pointer-events-none absolute -bottom-10 right-0 h-72 w-72 rounded-full bg-primary/10 blur-3xl" />

    <div className="relative mx-auto max-w-3xl px-6 md:px-12">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-center text-sm font-semibold uppercase tracking-[0.25em] text-primary"
      >
        The feeling, not the fee
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="mt-4 text-center font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl"
      >
        It was never about the <span className="italic text-primary">gift card.</span>
      </motion.h2>

      <div className="mt-16 space-y-10 md:space-y-12">
        {BEATS.map((beat, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="flex items-start gap-5"
            data-testid={`moment-beat-${i + 1}`}
          >
            <span className="mt-3 h-px w-10 shrink-0 bg-primary/50 md:w-16" />
            <p className="font-display text-2xl font-medium leading-snug tracking-tight sm:text-3xl">
              {beat.plain} <span className="text-primary">{beat.accent}</span>
            </p>
          </motion.div>
        ))}
      </div>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="mt-20 border-t border-border pt-10 text-center font-display text-2xl font-semibold leading-snug tracking-tight sm:text-3xl"
        data-testid="moment-payoff"
      >
        That's the gift. <span className="text-muted-foreground">A gift card's optional — the moment never was.</span>
      </motion.p>
    </div>
  </section>
);
